<footer class="footer">
    <div class="footer-content justify-content-between">
        <p class="m-b-0">
          Copyright © 2020 - {{ date | date:'y' }} by NetBrick GmbH. {{ 'Alle Rechte vorbehalten.' | translate }}<br>
          <small>Version {{ version }} | {{ commitHash }}</small>
        </p>
        <span>
            <a href="https://hausmeisterapp.com/impressum/" target="_blank" class="text-gray m-r-15">{{ 'Impressum' | translate }}</a>
            <a href="https://hausmeisterapp.com/datenschutz/" target="_blank" class="text-gray m-r-15">{{ 'Datenschutz' | translate }}</a>
            <a href="https://hilfe.hausmeisterapp.com" target="_blank" class="text-gray">{{ 'Helpcenter' | translate }}</a>
        </span>
    </div>
</footer>
